import LocationInformation from 'components/LocationInformation/LocationInformation.component';

const LocationInformationPage = () => {
	return <LocationInformation />;
};

export default LocationInformationPage;
